export const prepareMACD = (data, value) => {
    return {
        macd: data.map((d, i) => ({
            x: new Date(d.start_date),
            y: value.macd[i] !== undefined ? value.macd[i] : null,
        })),
        signal: data.map((d, i) => ({
            x: new Date(d.start_date),
            y: value.signal[i] !== undefined ? value.signal[i] : null,
        })),
        histogram: data.map((d, i) => ({
            x: new Date(d.start_date),
            y: value.histogram[i] !== undefined ? value.histogram[i] : null,
        })),
    };
};
